import React from 'react'
import { StyleSheet } from 'react-native'

import { B2, colors, Stack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import { i18n } from '@zet/localization'
import { DEVICE_HEIGHT, DEVICE_WIDTH } from '@zet/utils/Constants'
import { MenuTooltipProps } from '@zet/zet-prime'
import HELP_AND_SUPPORT from '@zet/zet-prime/assets/svgs/helpAndSupport.svg'

export default function MenuTooltip({
  onSupport,
  setShowTooltip,
  setIsCancelSubscriptionSheetVisible,
}: MenuTooltipProps) {
  const handleCancelSubscription = () => {
    setShowTooltip(false)
    // setIsCancelSubscriptionSheetVisible(true)
  }
  const handleSupport = () => {
    setShowTooltip(false)
    onSupport()
  }
  const handleBackdropPress = () => {
    setShowTooltip(false)
  }
  return (
    <Pressable style={styles.backdrop} onPress={handleBackdropPress}>
      <Stack style={styles.tooltip}>
        {/* <Pressable style={styles.tooltipItem} onPress={handleCancelSubscription}>
      <CANCEL_SUBSCRIPTION color={colors.grays[70]} />
        <B2 className="text-grays-70 ml-1">
          {i18n.t('zetPrime.cancelSubscription')}
        </B2>
      </Pressable> */}
        {/* <Stack className={`h-[1] w-full bg-grays-30`} /> */}
        <Pressable style={styles.tooltipItem} onPress={handleSupport}>
          <HELP_AND_SUPPORT color={colors.grays[70]} />
          <B2 className="text-grays-70 ml-1">{i18n.t('zetPrime.support')}</B2>
        </Pressable>
      </Stack>
    </Pressable>
  )
}

const styles = StyleSheet.create({
  backdrop: {
    height: DEVICE_HEIGHT + 50,
    width: DEVICE_WIDTH,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    position: 'absolute',
    left: 0,
    top: -50,
    right: 0,
    bottom: 0,
    zIndex: 1000,
  },
  tooltip: {
    position: 'absolute',
    top: 100,
    right: 32,
    backgroundColor: 'white',
    borderRadius: 12,
    paddingVertical: 8,
    paddingHorizontal: 12,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 8,
    minWidth: 180,
  },
  tooltipItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 8,
  },
})
